export const APP_TOUR_CONFIG = [
  {
    target: '#inbox-nav',
    title: 'Inbox',
    content: 'Reply to comments and mentions from a single place ',
    placement: 'right'
  },
  {
    target: '#your-work-nav',
    title: 'All your work in one place',
    content:
      'This is where you will see everything you own in the selected timeline (top right) <br/><br/> - Goals<br/> - Key Results<br/> - Initiatives',
    placement: 'right'
  },
  {
    target: '#org-goals-nav',
    title: 'Your Organization Goals',
    content:
      "See your organization's goals and align your work with what your company wants to achieve.",
    placement: 'right'
  },
  {
    target: '#team-goals-nav',
    title: 'These are Team Goals',
    content:
      'See team goals and how they align to your organization goals. Teams can be cross-functional workgroups or departments',
    placement: 'right'
  },
  {
    target: '#explore-all-nav',
    title: 'All Reports in one view',
    content: 'See all Activity, Goals and Initiatives reports across all teams in a single view.',
    placement: 'right'
  },
  {
    target: '#lists-nav-accordion',
    title: 'Your personal lists',
    content: 'Create your own custom views based on filters for quick access',
    placement: 'right'
  },
  {
    target: '#settings-nav',
    title: 'Your Profile and Settings',
    content: 'Manage your profile and Org Settings. Use this to invite others to North.',
    placement: 'right'
  },
  {
    target: '#open-notification-center',
    title: 'Get Important Alerts',
    content: 'When someone @ mentions you or gives you an award, this is where you’ll see them.',
    placement: 'top'
  },
  {
    target: '#timeline-dropdown',
    title: 'See Goals from different timelines',
    content:
      'Goals belong to a timeline. Change this timelime to see goals from a different time period.',
    placement: 'top'
  },
  {
    target: '#spotlight-search',
    title: 'Quick Search',
    content: 'Quickly find Goals, KRs or Initiatives in North. See your recent searches.',
    placement: 'top'
  }
]
